/**
 * Iconos del módulo de Vocabulario, portados del bundle de diseño
 * (`app-data.jsx`). SVG inline, stroke = currentColor por default.
 */

interface IconProps {
  size?: number;
  color?: string;
  fill?: string;
}

export const AIconTrash = ({ size = 16, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 7 H 20" />
    <path d="M9 7 V 5 a 1 1 0 0 1 1 -1 H 14 a 1 1 0 0 1 1 1 V 7" />
    <path d="M6 7 L 7 20 a 1 1 0 0 0 1 1 H 16 a 1 1 0 0 0 1 -1 L 18 7" />
    <path d="M10 11 V 17 M 14 11 V 17" />
  </svg>
);

export const AIconCheck = ({ size = 14, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12 L 10 18 L 20 6" />
  </svg>
);

export const AIconClose = ({ size = 13, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2.6" strokeLinecap="round">
    <path d="M6 6 L 18 18 M 18 6 L 6 18" />
  </svg>
);

export const AIconSearch = ({ size = 16, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.9" strokeLinecap="round">
    <circle cx="11" cy="11" r="6" />
    <path d="M16 16 L 21 21" />
  </svg>
);

export const AIconPlus = ({ size = 14, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round">
    <path d="M12 5 V 19 M 5 12 H 19" />
  </svg>
);

export const AIconPencil = ({ size = 14, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.9" strokeLinejoin="round" strokeLinecap="round">
    <path d="M4 20 L 4 16 L 15 5 L 19 9 L 8 20 Z" />
    <path d="M13 7 L 17 11" />
  </svg>
);

export const AIconGrip = ({ size = 14, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill={color} stroke="none">
    <circle cx="9" cy="6" r="1.5" /><circle cx="15" cy="6" r="1.5" />
    <circle cx="9" cy="12" r="1.5" /><circle cx="15" cy="12" r="1.5" />
    <circle cx="9" cy="18" r="1.5" /><circle cx="15" cy="18" r="1.5" />
  </svg>
);

